(() => {
  const elements = [
    ['.header--root', '--header--height'],
    ['.announcement--root', '--announcement--height']
  ];

  // Perf fix: the previous version read getBoundingClientRect() for one
  // element, wrote a layout-affecting CSS variable, then immediately read
  // getBoundingClientRect() for the next element - a read/write/read
  // interleave that forces the browser to synchronously recompute layout
  // mid-script (Lighthouse's "forced reflow" diagnostic). Fixed by
  // separating this into a READ phase (measure everything) and a WRITE
  // phase (apply everything), and by sharing one ResizeObserver + one
  // rAF-batched write pass across all tracked elements instead of one
  // observer per element, so resize events can't reintroduce the same
  // interleaving.

  const targets = elements
    .map(([selector, property]) => {
      const element = document.querySelector(selector);
      return element ? { element, property } : null;
    })
    .filter(Boolean);

  if (!targets.length) return;

  let scheduled = false;

  const applyAll = () => {
    scheduled = false;

    // READ phase - measure every tracked element before writing anything.
    const measurements = targets.map(({ element, property }) => ({
      property,
      height: element.getBoundingClientRect().height
    }));

    // WRITE phase - apply all styles after all reads are complete.
    measurements.forEach(({ property, height }) => {
      document.documentElement.style.setProperty(property, `${height.toFixed(2)}px`);
    });
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(applyAll);
  };

  window.requestAnimationFrame(applyAll);

  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(schedule);
    targets.forEach(({ element }) => observer.observe(element));
  }
})();
